var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('search-card',{attrs:{"title":"Hızlı Araç Sorgulama"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }